import removeNamespace from "../namespace-helper"

export const Types = {
  getters: {},
  actions: {
    CONFIRM: "dialog/CONFIRM",
  },
  mutations: {
    SHOW: "dialog/SHOW",
    HIDE: "dialog/HIDE",
    TITLE: "dialog/TITLE",
    MESSAGE: "dialog/MESSAGE",
    CALLBACK: "dialog/CALLBACK",
  },
}

const _types = removeNamespace("dialog/", Types)

const state = {
  title: "",
  message: "",
  callback: () => {},
  display: false,
}

// getters
const getters = {}

// actions
const actions = {
  [_types.actions.CONFIRM]: ({ commit }, payload) => {
    commit(_types.mutations.SHOW)
    commit(_types.mutations.TITLE, payload.title)
    commit(_types.mutations.MESSAGE, payload.message)
    commit(_types.mutations.CALLBACK, payload.callback)
  },
}

// mutations
const mutations = {
  [_types.mutations.SHOW]: state => {
    state.display = true
  },
  [_types.mutations.HIDE]: state => {
    state.display = false
  },
  [_types.mutations.TITLE]: (state, title) => {
    state.title = title
  },
  [_types.mutations.MESSAGE]: (state, message) => {
    state.message = message
  },
  [_types.mutations.CALLBACK]: (state, callback) => {
    state.callback = callback
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
